jQuery(function ($) {
    const loader = document.getElementById("loading-spinner");
    let isLoading = false;
    let hideTimeout = null;

    const showLoader = () => {
        if (!isLoading && loader) {
            loader.classList.add("active");
            isLoading = true;
        }
    };

    const hideLoader = () => {
        if (hideTimeout) clearTimeout(hideTimeout);

        hideTimeout = setTimeout(() => {
            if (loader) {
                loader.classList.remove("active");
                isLoading = false;
            }
        }, 500);
    };

    // Small helper to decide if we should show/hide the loader
    function shouldToggleLoader(settings) {
        if (!settings || !settings.url || settings.url.indexOf('admin-ajax.php') === -1) return false;

        // skip if it's the live search
        if (settings.url.indexOf('action=searchwp_live_search') !== -1) return false;

        // skip if it's click_and_collect (handle various data shapes, but keep it short)
        if (typeof settings.data === 'string' && settings.data.indexOf('action=click_and_collect') !== -1) return false;
        if (settings.data && typeof settings.data === 'object') {
            // plain object
            if (settings.data.action === 'click_and_collect') return false;
            // FormData / URLSearchParams
            if (typeof settings.data.get === 'function' && settings.data.get('action') === 'click_and_collect') return false;
            // serializeArray()
            if (Array.isArray(settings.data) && settings.data.some(function (p) { return p && p.name === 'action' && p.value === 'click_and_collect'; })) return false;
        }

        return true;
    }

    $(document).ajaxSend(function (event, jqXHR, settings) {
        if (shouldToggleLoader(settings)) showLoader();
    });

    $(document).ajaxComplete(function (event, jqXHR, settings) {
        if (shouldToggleLoader(settings)) hideLoader();
    });


    /**
     * Override WooCommerce's default .block() behaviour on specific elements.
     * These include cart and checkout blocks where WooCommerce normally applies blockUI.
     * If the element is one of our targets, suppress WooCommerce's UI blocking.
     */
    const originalBlock = $.fn.block;
    const originalUnblock = $.fn.unblock;

    $.fn.block = function () {
        const suppress = this.filter(function () {
            const el = this;
            return (
                el.classList.contains('woocommerce-cart-form') || // cart form
                el.classList.contains('cart') ||                  // generic cart wrapper
                el.id === 'cart' ||                               // cart container
                el.id === 'order_review' ||                       // checkout order review
                el.id === 'checkout' ||                           // checkout form
                el.id === 'payment' ||                            // payment section
                el.classList.contains('woocommerce-checkout-review-order-table') || // order table
                el.classList.contains('checkout__review-col') || // layout column
                el.classList.contains('checkout-payment')         // checkout payment wrapper
            );
        });

        // Return the element without applying blockUI if suppression matched
        return suppress.length > 0 ? this : originalBlock.apply(this, arguments);
    };

    /**
     * Override WooCommerce's .unblock() behaviour using the same logic as above.
     * Prevent it from showing/removing overlays on our managed elements.
     */
    $.fn.unblock = function () {
        const suppress = this.filter(function () {
            const el = this;
            return (
                el.classList.contains('woocommerce-cart-form') ||
                el.classList.contains('cart') ||
                el.id === 'cart' ||
                el.id === 'order_review' ||
                el.id === 'checkout' ||
                el.id === 'payment' ||
                el.classList.contains('woocommerce-checkout-review-order-table') ||
                el.classList.contains('checkout__review-col') ||
                el.classList.contains('checkout-payment')
            );
        });

        return suppress.length > 0 ? this : originalUnblock.apply(this, arguments);
    };

    /**
     * Checkout-specific logic:
     * WooCommerce checkout-related event hooks:
     * These fire during AJAX events such as when shipping, payment, or totals are updated.
     */
    const body = $(document.body);
    body.on("checkout_place_order", showLoader); // trigger loader when an order is placed
    body.on("checkout_error checkout_place_order_success", hideLoader); // hide loader when checkout is done, errored, or completed

    /**
     * Variation Product-specific logic:
     * When WooCommerce starts checking for a matching product variation,
     * show the loader (this is triggered when variation dropdowns are used).
     */
    $('.variations_form').on('check_variations', function () {
        showLoader();
    });

    /**
     * Variation Product-specific logic:
     * When WooCommerce has either found a valid variation or reset the variation UI,
     * hide the loader (variation check complete).
     */
    $('.variations_form').on('found_variation reset_data', function () {
        hideLoader();
    });

    /**
     * Cart-specific logic:
     * - `updated_cart_totals`: Fired when the cart totals section is refreshed (e.g. after clicking "Update cart").
     * - `updated_wc_div`: Fired when WooCommerce dynamically replaces the entire cart area via AJAX
     *   (e.g. after removing an item or updating quantity.).
     * 
     * These events signal that cart processing is complete, so we hide the loader.
     */
    body.on('updated_cart_totals updated_wc_div', function () {
        hideLoader();
    });

    /**
     * Cart-specific logic:
     * Trigger loader when the user clicks the "Update cart" button.
     */
    $(document).on('click', '[name="update_cart"]', function () {
        showLoader();
    });

    /**
     * Cart-specific logic:
     * Trigger loader when a user removes a cart item (X button).
     * This typically refreshes the cart with AJAX.
     */
    $(document).on('click', '.woocommerce-cart-form .remove', function () {
        showLoader();
    });
});